/* LAUVEE - Fiche produit (refonte 2026)
   1. Blocs additionnels remis a leur place dans la colonne
   2. Sous-titre gris + pastilles
   3. Note « 4.7/5 - ADOPTE PAR +46,000 CLIENT(E)S » (seule la mention est soulignee, clic = avis)
   4. Prix affiche et maintenu dans le bouton d'ajout au panier
   5. Accordeon Description alimente par la description Shopify
   6. Bandeau de reassurance rotatif
   7. Galerie : une grande image, miniatures, puces, balayage et transition
      glissee (l'image sortante part d'un cote, l'entrante arrive de l'autre).
      Uniquement dans #featuredProduct : pas sur les accessoires.
   8. Scalapay : retrait du cadre (le widget est en shadow DOM)

   L'ordre des blocs de la colonne est gere en CSS (propriete order).
   ATTENTION : les puces de la galerie s'appellent .lv-gal-dot(s) et NON
   .lv-dot, deja utilise par le carrousel de la section infosProduit.
*/
(function () {
  'use strict';

  /* Valeurs de secours : le sous-titre et les pastilles propres a chaque fiche
     sont lus dans [data-lv-headline] (snippets/lauvee-product-extras.liquid). */
  var PILLS = ['Nettoyer', 'Masser', 'Drainer'];
  var SUBTITLE = 'Technologie sonique DMC System + Silicone antibactérien';
  var SLIDE_MS = 420;

  function q(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function host() {
    return q('.product__info-container > div');
  }

  function plain(text) {
    return String(text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  /* 1. Les blocs additionnels sont rendus depuis buy-buttons, donc imbriques
     dans le bloc du bouton. Le CSS ne peut les ordonner que s'ils sont
     enfants directs de la colonne : on les remonte. */
  function relocate() {
    var parent = host();
    if (!parent) return;

    ['.lv-pdp-benefits', '.lv-pdp-accordions'].forEach(function (selector) {
      var block = q(selector);
      if (block && block.parentElement !== parent) parent.appendChild(block);
    });
  }

  /* 2. Sous-titre + pastilles, propres a chaque fiche (lus dans
     [data-lv-headline]). Pas sur les accessoires : le marqueur
     data-lv-accessory est pose par snippets/lauvee-product-extras.liquid. */
  function initPills() {
    var parent = host();
    if (!parent || q('.lv-pdp-headline', parent)) return;
    if (q('[data-lv-accessory]')) return;
    if (!q('.product__title', parent)) return;

    var conf = q('[data-lv-headline]');
    var subtitle = (conf && conf.getAttribute('data-subtitle')) || SUBTITLE;
    var labels = conf && conf.getAttribute('data-pills')
      ? conf.getAttribute('data-pills').split('|')
      : PILLS;

    var block = document.createElement('div');
    block.className = 'lv-pdp-headline';

    var sub = document.createElement('p');
    sub.className = 'lv-pdp-subtitle';
    sub.textContent = subtitle;
    block.appendChild(sub);

    var pills = document.createElement('div');
    pills.className = 'lv-pdp-pills';
    labels.forEach(function (label) {
      if (!label.trim()) return;
      var pill = document.createElement('span');
      pill.className = 'lv-pdp-pill';
      pill.textContent = label.trim();
      pills.appendChild(pill);
    });
    block.appendChild(pills);

    parent.appendChild(block);
  }

  /* 3. Note a cote des etoiles : « 4.7/5 - ADOPTE PAR +46,000 CLIENT(E)S ».
     Le clic sur le badge descend jusqu'aux avis Judge.me en bas de page. */
  var SOCIAL_PROOF = 'adopté par +46,000 client(e)s';

  function initRating() {
    var badge = q('.product__info-container .jdgm-prev-badge');
    if (!badge) return;

    var text = q('.jdgm-prev-badge__text', badge);
    if (!text) return;

    var score = parseFloat(badge.getAttribute('data-average-rating'));
    var count = parseInt(badge.getAttribute('data-number-of-reviews'), 10);
    if (isNaN(score) || isNaN(count)) return;

    if (!badge.hasAttribute('data-lv-scroll')) {
      badge.setAttribute('data-lv-scroll', '');
      badge.style.cursor = 'pointer';
      badge.addEventListener('click', function () {
        var reviews = q('#judgeme_product_reviews') || q('.jdgm-review-widget');
        if (reviews) reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    var expected = score.toFixed(1) + '/5 - ' + SOCIAL_PROOF;
    if (plain(text.textContent) === plain(expected)) return;

    text.innerHTML =
      score.toFixed(1) + '/5 - ' +
      '<span class="lv-rating-count">' + SOCIAL_PROOF + '</span>';
  }

  function watchRating() {
    var widget = q('.product__info-container .jdgm-preview-badge');
    if (!widget) return;

    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(initRating, 80);
    }).observe(widget, { childList: true, subtree: true, characterData: true });
  }

  /* 4. Prix dans le bouton. Le script du theme reecrit le libelle a chaque
     changement de variante : on le redecore ensuite. */
  function currentPriceText() {
    /* Fiche de la tete : prix de la formule choisie (abonnement ou achat
       unique), pose par assets/lauvee-subscription.js. */
    var sub = q('[data-lv-sub-override]');
    if (sub && sub.getAttribute('data-lv-sub-override')) return sub.getAttribute('data-lv-sub-override');

    var container = q('.product__info-container [id^="price-"]');
    if (!container) return null;

    var price = q('.price', container) || container;
    var onSale = price.classList && price.classList.contains('price--on-sale');
    var target = onSale ? q('.price-item--sale', price) : q('.price-item--regular', price);

    target = target || q('.price-item--sale', price) || q('.price-item--regular', price);
    if (!target) return null;

    var text = target.textContent.replace(/\s+/g, ' ').trim();
    return text || null;
  }

  function isDisabled(button) {
    return !button || button.disabled || button.getAttribute('aria-disabled') === 'true';
  }

  function decorateButtons() {
    var price = currentPriceText();
    if (!price) return;

    qa('.product-form__submit .button-text').forEach(function (span) {
      var button = span.closest('.product-form__submit');
      if (isDisabled(button)) return;

      var priceEl = q('[data-lv-btn-price]', span);

      if (!priceEl) {
        var label = span.textContent.replace(/\s+/g, ' ').trim();
        if (!label) return;

        span.innerHTML =
          '<span class="lv-btn-label"></span>' +
          '<span class="lv-btn-sep" aria-hidden="true">&ndash;</span>' +
          '<span class="lv-btn-price" data-lv-btn-price></span>';

        q('.lv-btn-label', span).textContent = label;
        priceEl = q('[data-lv-btn-price]', span);
      }

      if (priceEl.textContent.trim() !== price) priceEl.textContent = price;
    });
  }

  function watchPrice() {
    var timer;
    var schedule = function () {
      clearTimeout(timer);
      timer = setTimeout(decorateButtons, 60);
    };

    var container = q('.product__info-container [id^="price-"]');
    if (container) {
      new MutationObserver(schedule).observe(container, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    qa('product-form').forEach(function (form) {
      new MutationObserver(schedule).observe(form, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled']
      });
    });
  }

  /* 5. Accordeon Description : on reprend la description Shopify en retirant
     les lignes « ✔ » qui alimentent deja la grille de benefices. */
  function fillDescription() {
    var body = q('[data-lv-acc-description-body]');
    var source = q('.product__info-container .product__description');
    if (!body || !source || body.getAttribute('data-filled')) return;

    var titles = qa('.lv-pdp-benefit__title').map(function (el) {
      return plain(el.textContent);
    });

    var clone = (q('.product__description-wrap', source) || source).cloneNode(true);

    qa('*', clone).forEach(function (el) {
      if (el.parentElement !== clone) return;

      var text = plain(el.textContent);
      if (text.indexOf('✔') !== 0 && text.indexOf('✓') !== 0) return;

      var covered = titles.some(function (title) {
        return title && text.indexOf(title) !== -1;
      });

      if (covered) el.parentNode.removeChild(el);
    });

    if (!clone.textContent.trim()) return;

    body.innerHTML = clone.innerHTML;
    body.setAttribute('data-filled', '1');

    var parent = host();
    if (parent) parent.classList.add('lv-ready');
  }

  /* 6. Bandeau de reassurance rotatif */
  function initUsp() {
    var root = q('[data-lv-usp]');
    if (!root || root.getAttribute('data-lv-usp-ready')) return;

    var items = qa('.lv-pdp-usp__item', root);
    var dotsWrap = q('[data-lv-usp-dots]', root);
    if (items.length < 2) {
      if (dotsWrap) dotsWrap.style.display = 'none';
      return;
    }

    root.setAttribute('data-lv-usp-ready', '1');

    var delay = parseInt(root.getAttribute('data-lv-usp-delay'), 10) || 2000;
    var index = 0;
    var timer = null;
    var dots = [];

    function go(next) {
      if (next === index) return;

      var previous = index;
      items[previous].classList.remove('is-active');
      items[previous].classList.add('is-leaving');
      setTimeout(function () {
        items[previous].classList.remove('is-leaving');
      }, 500);

      index = next;
      items[index].classList.add('is-active');
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function stop() {
      clearInterval(timer);
    }

    function start() {
      stop();
      timer = setInterval(function () {
        go((index + 1) % items.length);
      }, delay);
    }

    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      items.forEach(function (item, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'lv-pdp-usp__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Message ' + (i + 1));
        dot.addEventListener('click', function () {
          go(i);
          start();
        });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    start();
  }

  /* 7. Galerie
     Reservee a la section #featuredProduct (brosse L1, tete de rechange).
     Les accessoires utilisent le template product.product (section
     main-product), qui a deja ses propres miniatures : y construire les notres
     les dupliquait en grand, par-dessus la colonne de texte. */
  function mediaList() {
    return q('#featuredProduct .product__media-wrapper .product__media-list');
  }

  /* Le theme masque les photos des autres couleurs via un style inline.
     On lit donc le style inline (et non le style calcule, que nos propres
     regles CSS modifient) pour savoir ce qui doit etre propose. */
  function themeVisible(li) {
    return li.tagName === 'LI' && li.style.display !== 'none';
  }

  function visibleItems(list) {
    return Array.prototype.filter.call(list.children, themeVisible);
  }

  function activeIndex(list) {
    var items = visibleItems(list);
    for (var i = 0; i < items.length; i++) {
      if (items[i].classList.contains('lv-active')) return i;
    }
    return 0;
  }

  function thumbnailUrl(img) {
    var src = img.currentSrc || img.src || '';
    if (!src) return '';
    if (/([?&]width=)\d+/.test(src)) return src.replace(/([?&]width=)\d+/, '$1300');
    return src;
  }

  /* L'image sortante glisse d'un cote pendant que l'entrante arrive de
     l'autre : les deux restent affichees le temps de l'animation. */
  function slide(previous, next, direction) {
    if (!previous || previous === next) return;

    var out = direction > 0 ? 'lv-out-left' : 'lv-out-right';
    var enter = direction > 0 ? 'lv-in-right' : 'lv-in-left';

    previous.classList.add('lv-leaving', out);
    next.classList.add(enter);

    clearTimeout(previous.lvAnim);
    previous.lvAnim = setTimeout(function () {
      previous.classList.remove('lv-leaving', 'lv-out-left', 'lv-out-right');
    }, SLIDE_MS);

    clearTimeout(next.lvAnim);
    next.lvAnim = setTimeout(function () {
      next.classList.remove('lv-in-right', 'lv-in-left');
    }, SLIDE_MS);
  }

  function setActive(li, direction) {
    var list = li.parentElement;
    if (!list) return;

    var previous = null;
    Array.prototype.forEach.call(list.children, function (el) {
      if (el.classList.contains('lv-active')) previous = el;
    });

    Array.prototype.forEach.call(list.children, function (el) {
      var isActive = el === li;
      el.classList.toggle('lv-active', isActive);
      if (el.lvThumb) el.lvThumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      if (el.lvDot) el.lvDot.classList.toggle('is-active', isActive);
    });

    if (direction) slide(previous, li, direction);
  }

  /* Passage a une photo precise (miniature ou puce) : le sens de l'animation
     depend de sa position par rapport a la photo courante. */
  function goTo(li) {
    var list = li.parentElement;
    if (!list) return;

    var items = visibleItems(list);
    var to = items.indexOf(li);
    var from = activeIndex(list);
    if (to === from || to < 0) return;

    setActive(li, to > from ? 1 : -1);
  }

  /* Puces facon reference : en bas a droite DANS l'image, sur mobile. */
  function buildDots(items, list) {
    var stage = list.closest('slider-component') || list.parentElement;
    if (!stage) return;

    stage.classList.add('lv-stage');

    var dots = q('.lv-gal-dots', stage);
    if (!dots) {
      dots = document.createElement('div');
      dots.className = 'lv-gal-dots';
      stage.appendChild(dots);
    }

    dots.innerHTML = '';
    if (items.length < 2) return;

    items.forEach(function (li, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'lv-gal-dot';
      dot.setAttribute('aria-label', 'Photo ' + (index + 1));
      dot.addEventListener('click', function () {
        goTo(li);
      });

      li.lvDot = dot;
      dots.appendChild(dot);
    });
  }

  /* Balayage au doigt et a la souris. */
  function initSwipe() {
    var list = mediaList();
    if (!list) return;

    var stage = list.closest('slider-component') || list.parentElement;
    if (!stage || stage.lvSwipeReady) return;
    stage.lvSwipeReady = true;

    var startX = 0;
    var startY = 0;
    var tracking = false;
    var swiped = false;

    function step(direction) {
      var items = visibleItems(list);
      if (items.length < 2) return;

      var next = (activeIndex(list) + direction + items.length) % items.length;
      setActive(items[next], direction);
    }

    function begin(x, y) {
      startX = x;
      startY = y;
      tracking = true;
      swiped = false;
    }

    function end(x, y) {
      if (!tracking) return;
      tracking = false;

      var dx = x - startX;
      var dy = y - startY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;

      swiped = true;
      step(dx < 0 ? 1 : -1);
    }

    stage.addEventListener(
      'touchstart',
      function (event) {
        if (event.touches.length !== 1) return;
        begin(event.touches[0].clientX, event.touches[0].clientY);
      },
      { passive: true }
    );

    stage.addEventListener(
      'touchend',
      function (event) {
        var touch = event.changedTouches[0];
        if (touch) end(touch.clientX, touch.clientY);
      },
      { passive: true }
    );

    stage.addEventListener('mousedown', function (event) {
      begin(event.clientX, event.clientY);
    });

    stage.addEventListener('mouseup', function (event) {
      end(event.clientX, event.clientY);
    });

    /* Un glissement ne doit pas ouvrir la visionneuse. */
    stage.addEventListener(
      'click',
      function (event) {
        if (!swiped) return;
        swiped = false;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );
  }

  function buildThumbs() {
    var list = mediaList();
    if (!list) return;

    var wrapper = list.closest('.product__media-wrapper');
    if (!wrapper) return;
    wrapper.classList.add('lv-gallery');

    var thumbs = q('.lv-thumbs', wrapper);
    if (!thumbs) {
      thumbs = document.createElement('div');
      thumbs.className = 'lv-thumbs';
      wrapper.appendChild(thumbs);
    }

    var items = visibleItems(list);
    thumbs.innerHTML = '';

    items.forEach(function (li, index) {
      var img = li.querySelector('img');
      var button = document.createElement('button');

      button.type = 'button';
      button.className = 'lv-thumb';
      button.setAttribute('aria-label', 'Voir la photo ' + (index + 1));

      if (img) {
        var thumb = document.createElement('img');
        thumb.src = thumbnailUrl(img);
        thumb.alt = '';
        thumb.loading = 'lazy';
        button.appendChild(thumb);
      }

      button.addEventListener('click', function () {
        goTo(li);
      });

      li.lvThumb = button;
      thumbs.appendChild(button);
    });

    buildDots(items, list);

    var active = items.filter(function (li) {
      return li.classList.contains('lv-active');
    })[0];

    if (!active) active = items[0];
    if (active) setActive(active);
  }

  function watchGallery() {
    var list = mediaList();
    if (!list) return;

    var timer;
    new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        return mutation.target && mutation.target.tagName === 'LI';
      });
      if (!relevant) return;

      clearTimeout(timer);
      timer = setTimeout(buildThumbs, 80);
    }).observe(list, { attributes: true, attributeFilter: ['style'], subtree: true });
  }

  /* 8. Scalapay : le widget est en shadow DOM, le CSS du theme ne l'atteint
     pas. On injecte donc une feuille dans son shadow root. */
  function styleScalapay() {
    var widget = q('scalapay-widget');
    if (!widget || !widget.shadowRoot) return false;
    if (widget.shadowRoot.querySelector('#lv-scalapay-style')) return true;

    var style = document.createElement('style');
    style.id = 'lv-scalapay-style';
    style.textContent =
      'article{border:0!important;background:transparent!important;' +
      'padding:0!important;border-radius:0!important;box-shadow:none!important}' +
      ':host>div{padding-top:0!important;padding-bottom:0!important}';

    widget.shadowRoot.appendChild(style);
    return true;
  }

  function watchScalapay() {
    if (styleScalapay()) return;

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (styleScalapay() || tries > 40) clearInterval(timer);
    }, 250);
  }

  /* ---------------------------------------------------------------------- */
  function layout() {
    relocate();
    initPills();
    initRating();
    decorateButtons();
    fillDescription();
    initUsp();
    buildThumbs();
    initSwipe();
    styleScalapay();
  }

  function init() {
    layout();
    watchRating();
    watchPrice();
    watchGallery();
    watchScalapay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', layout);
})();
